interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  description?: string;
  inverse?: boolean;
}

export function SectionHeading({
  index,
  eyebrow,
  title,
  description,
  inverse = false,
}: SectionHeadingProps) {
  return (
    <div className={`section-heading ${inverse ? "section-heading--inverse" : ""}`}>
      <div className="section-heading__meta">
        <span>{index}</span>
        <span>{eyebrow}</span>
      </div>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
  );
}
